import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { DASHBOARD_ROUTES as DASHBOARD_ROUTE_CONSTANTS } from '../../route-constants';

const RootPage = lazy(() => import('@~/pages/root/root'));
const HomePage = lazy(() => import('@~/pages/home/home'));
const DashboardHome = lazy(() => import('@~/screens/dashboard/home'));
const ChapterAndSheetContainer = lazy(() => import('@~/screens/chapter-sheet-container'));
const StudentChapter = lazy(() => import('@~/pages/home/chapter/chapter'));
const PendingSheets = lazy(() => import('@~/screens/pending'));
const WinsDashboard = lazy(() => import('@~/screens/wins-dashboard'));
const PuzzleDashboard = lazy(
  () => import('@~/pages/puzzles-dashboard/puzzles-dashboard'),
);

export const DASHBOARD_ROUTES: RouteObject[] = [
  {
    path: DASHBOARD_ROUTE_CONSTANTS.ROOT.PATH,
    element: <RootPage />,
    handle: {
      pageName: DASHBOARD_ROUTE_CONSTANTS.ROOT.NAME,
    },
  },
  {
    path: DASHBOARD_ROUTE_CONSTANTS.HOME.PATH,
    element: <HomePage />,
    handle: {
      pageName: DASHBOARD_ROUTE_CONSTANTS.HOME.NAME,
    },
  },
  {
    path: DASHBOARD_ROUTE_CONSTANTS.LEGACY_HOME.PATH,
    element: <DashboardHome />,
    handle: {
      pageName: DASHBOARD_ROUTE_CONSTANTS.LEGACY_HOME.NAME,
    },
  },
  {
    path: DASHBOARD_ROUTE_CONSTANTS.CHAPTER.PATH,
    element: <ChapterAndSheetContainer />,
    handle: {
      pageName: DASHBOARD_ROUTE_CONSTANTS.CHAPTER.NAME,
    },
  },
  {
    path: DASHBOARD_ROUTE_CONSTANTS.CHAPTERS.PATH,
    element: <StudentChapter />,
    handle: {
      pageName: DASHBOARD_ROUTE_CONSTANTS.CHAPTERS.NAME,
    },
  },
  {
    path: DASHBOARD_ROUTE_CONSTANTS.PENDING.PATH,
    element: <PendingSheets />,
    handle: {
      pageName: DASHBOARD_ROUTE_CONSTANTS.PENDING.NAME,
    },
  },
  {
    path: DASHBOARD_ROUTE_CONSTANTS.WINS.PATH,
    element: <WinsDashboard />,
    handle: {
      pageName: DASHBOARD_ROUTE_CONSTANTS.WINS.NAME,
    },
  },
  {
    path: DASHBOARD_ROUTE_CONSTANTS.PUZZLES_DASHBOARD.PATH,
    element: <PuzzleDashboard />,
    handle: {
      pageName: DASHBOARD_ROUTE_CONSTANTS.PUZZLES_DASHBOARD.NAME,
    },
  },
];
